import { useCallback } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { ButtonSmall } from "../../../components/Button"
import { TStore } from "../../../store/Store"

import unauthorized_access from "../../../assets/images/401_image.svg"
import styles from "../error.module.scss"

const UnauthorizedAccess = () => {
    const navigate = useNavigate()
    const { redirectModule } = useSelector((store: TStore) => store.verifyLogin)
    const handleRedirect = useCallback(() => {
        const routeMap: {
            [key: string]: string
        } = {
            Projects: "/Projects",
            Operations: "/Installation",
            Logistics: "/Logistics",
            "Customer Support": "/CustomerSupport",
            Onboarding: "/Onboarding",
            Finance: "/Finance",
            "Tech Support": "/TechSupport",
            "Network Reliability": "/NetworkReliability",
            Settings: "/Settings",
        }
        navigate(routeMap[redirectModule] ?? "/Settings")
    }, [redirectModule, navigate])

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.image_container}>
                    <img src={unauthorized_access} width={340} height={240} alt="Unauthorised Access" />
                </div>
                <div className={styles.text_section}>
                    <div className={styles.bold_section}>Unauthorised Access</div>
                    <div>Sorry your request can't be processed as you don't have access to this module</div>
                </div>
                <div className={styles.button_container}>
                    <ButtonSmall
                        className={`${styles.reload_button} ${styles.redirect_button}`}
                        onClick={handleRedirect}>
                        Return to home
                    </ButtonSmall>
                </div>
            </div>
        </div>
    )
}

export default UnauthorizedAccess
